import axios from '@plugins/axios';

class SistemaService {
    get(params = {}, options = {}) {
        return axios({
            url: `sistema`,
            method: 'GET',
            params,
            ...options
        });
    }
}

export const BaseSistemaService = SistemaService;

export default new SistemaService();